import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Button } from "V2.0/common/button";
import { TrashIcon } from "@heroicons/react/24/outline";
import { DocumentUpload } from "./DocumentUpload";
import { fileIcons } from "./DocumentsTable";

function FileIcon(props) {
  const { type } = props;
  const Icon = fileIcons[type];

  return <Icon className="size-6" />;
}

export default function DocumentUploadField(props) {
  const { files, onFileRemove, fileUploadError, onFileUpload } = props;

  return (
    <Field>
      <Label>Document *</Label>
      {Boolean(files.file) ? (
        <div className="flex gap-x-2 items-center justify-between overflow-hidden px-2 py-4 mb-2">
          <FileIcon type={files.file.type} />
          <p className="truncate flex-grow text-sm dark:text-gray-300 text-zinc-900 font">
            {files.file.name}
          </p>
          <Button
            plain
            onClick={onFileRemove}
            className="text-red-500 cursor-pointer"
          >
            <TrashIcon />
          </Button>
        </div>
      ) : (
        <DocumentUpload
          onChange={(file) => {
            onFileUpload(file);
          }}
        />
      )}
      {fileUploadError && <ErrorMessage>Please Upload a file</ErrorMessage>}
    </Field>
  );
}
